import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _regeneratorRuntime from "@babel/runtime/regenerator";
import { componentName } from "../../const";
import React, { useState, useEffect, useRef } from 'react';
import { useUpdateEffect, useUpdate } from 'react-use';
import { genRandomKey, parseJsonProps } from "../../utils";
import "./style/index.scss";

// !!! 注意 ViewProps 会被 ../index 使用

export function useFetchSchema(props) {
  var _ref = props || {},
    pageSelect = _ref.pageSelect;
  var _useState = useState(null),
    schema = _useState[0],
    setSchema = _useState[1];
  var _useState2 = useState(null),
    error = _useState2[0],
    setError = _useState2[1];
  var _ref2 = pageSelect || {},
    app = _ref2.app,
    page = _ref2.page,
    version = _ref2.version,
    schemaUrl = _ref2.schemaUrl;
  var _ref3 = app || {},
    appCode = _ref3.appCode;
  var _ref4 = page || {},
    pageId = _ref4.id;
  var _ref5 = version || {},
    pageVersion = _ref5.pageVersion,
    status = _ref5.status;
  var url = schemaUrl;
  if (!url && appCode && pageId && pageVersion) {
    var _window$_GATEWAY_PF, _window$_GATEWAY_PF2, _window$_GATEWAY_PF3;
    var isProdVersion = status === 'PROD';
    var isDevVersion = status === 'DAILY' || status === 'EDITING';
    var isPreview = location.pathname.indexOf('/lowcode/preview') !== -1;
    var isJoint = location.search.indexOf('__next_lowcode_pageId__') !== -1;
    // TODO 如果是线上环境, 是否强制加载线上资源?
    var isProd = ((_window$_GATEWAY_PF = window._GATEWAY_PF) === null || _window$_GATEWAY_PF === void 0 ? void 0 : _window$_GATEWAY_PF.env) === 'prod';
    var isDaily = ((_window$_GATEWAY_PF2 = window._GATEWAY_PF) === null || _window$_GATEWAY_PF2 === void 0 ? void 0 : _window$_GATEWAY_PF2.env) === 'daily';
    var isPre = ((_window$_GATEWAY_PF3 = window._GATEWAY_PF) === null || _window$_GATEWAY_PF3 === void 0 ? void 0 : _window$_GATEWAY_PF3.env) === 'pre';
    // 如果是日常版本, 使用日常域名, 其他情况使用线上域名, 这样判断安全一些
    var prefix = isDevVersion ? 'assets-daily.cainiao-inc.com' : 'cn.alicdn.com';
    url = "https://" + prefix + "/" + appCode + "/" + pageId + "/" + pageVersion + "/schema.json";
  }
  useEffect(function () {
    setError(null);
    function fetchSchema() {
      return _fetchSchema.apply(this, arguments);
    }
    function _fetchSchema() {
      _fetchSchema = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var res;
        return _regeneratorRuntime.wrap(function _callee$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.prev = 0;
              if (url) {
                _context2.next = 3;
                break;
              }
              return _context2.abrupt("return");
            case 3:
              _context2.next = 5;
              return fetch(url);
            case 5:
              res = _context2.sent;
              if (res.ok) {
                _context2.next = 9;
                break;
              }
              setError(new Error('Page load error'));
              return _context2.abrupt("return");
            case 9:
              setSchema(res.json());
              _context2.next = 15;
              break;
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](0);
              setError(_context2.t0);
            case 15:
            case "end":
              return _context2.stop();
          }
        }, _callee, null, [[0, 12]]);
      }));
      return _fetchSchema.apply(this, arguments);
    }
    fetchSchema()["catch"](function () {});
  }, [url]);
  return {
    url: url,
    schema: schema,
    error: error
  };
}
function View(props) {
  var className = props.className,
    _context = props._context,
    _jsonProps = props._jsonProps,
    _deps = props._deps,
    _destroryWhenDepsUpdate = props._destroryWhenDepsUpdate,
    onSaveThis = props.onSaveThis;
  var _useFetchSchema = useFetchSchema(props),
    url = _useFetchSchema.url,
    schema = _useFetchSchema.schema,
    error = _useFetchSchema.error;

  // _destroryWhenDepsUpdate
  var keyRef = useRef();
  var forceUpdate = useUpdate();
  useUpdateEffect(function () {
    if (_destroryWhenDepsUpdate) {
      keyRef.current = genRandomKey();
      forceUpdate();
    }
  }, _deps || []);
  if (!url) {
    return /*#__PURE__*/React.createElement("div", null, "404");
  }
  if (error) {
    // eslint-disable-next-line no-console
    console.warn('CnLowcodePageError', error);
    return /*#__PURE__*/React.createElement("div", null, "\u9875\u9762\u6E32\u67D3\u51FA\u9519: ", error.message || 'unknown error');
  }
  if (!schema) {
    return /*#__PURE__*/React.createElement("div", null);
  }
  var ConeRenderEngine = window.ConeRenderEngine || parent.ConeRenderEngine;
  var Block = ConeRenderEngine.Block;
  var pageProps = parseJsonProps({
    _context: _context,
    _jsonProps: _jsonProps
  });
  return /*#__PURE__*/React.createElement("div", {
    className: className
  }, /*#__PURE__*/React.createElement(Block, {
    key: keyRef.current,
    id: url,
    schema: schema,
    pageProps: pageProps,
    onSaveThis: onSaveThis
  }));
}
View.displayName = componentName;
export default View;